import { ModalOptions } from "@modules/+new/shared/universal-modal/entities/modal-options.interface";
import { ModalSizes } from "@modules/+new/shared/universal-modal/entities/modal-size.enum";
import { ModalHeadersEnum } from "@modules/+new/shared/universal-modal/components/_headers/headers.index";

export const UNIVERSAL_MODAL_DEFAULT_CONFIG: ModalOptions = {
	clearPathOnClose: true,
	clearPathOnOpen: false,
	showCancel: true,
	showPrevious: true,
	confirmCancel: false,
	isPreset: null,
	allowBackdropCancel: true,
	cancelKey: null,
	size: ModalSizes.md,
	extraClass: null,
	headerTitle: "",
	headerTitleKey: null,
	header: ModalHeadersEnum.twoSided,
	headerComponent: null,
	footer: null,
	footerComponent: null,
	wrap: true,
	goBackOnEscKey: false
};
